// extracted by mini-css-extract-plugin
export default {"page":"proxyrule_page__WZeCF","rule_bg":"proxyrule_rule_bg__oYFvY","proxy_rule_bg":"proxyrule_proxy_rule_bg__D8CxQ"};